import { membership } from 'apis';
import axiosInstance from '../axiosInstance';

export const membershipApi = {
    post: (path, params, options, cancelToken) => {
        return axiosInstance
            .post(`/membership${path}`, params, {
                ...options,
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            });
    },
    get: (path, params, options, cancelToken) =>
        axiosInstance
            .get(`/membership${path}`, params, {
                ...options,
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            })
};

export const confirmOneTimeAccess = async (params, options) => membershipApi.post('/ConfirmOneTimeAccess', params);

export const createOneTimeAccessLink = async (params, options) => membershipApi.post('/CreateOneTimeAccessLink', params);

export const register = async (params, options) => membershipApi.post('/Register', params);

export const transferAccount = async (params, options) => membershipApi.post('/TransferAccount', params);

export const getMembershipsDashboard = async () => membershipApi.get('/GetMembershipsDashboard');

export const getProfile = async (params) => membershipApi.get('/GetProfile', { params });

export const updateProfile = async (params) => membershipApi.post('/UpdateProfile', params);

export const createMember = async (params) => membershipApi.post('/CreateMember', params);

export const getAvatar = async (params) => membershipApi.post('/getAvatar', params);

export const removeAvatar = async (params) => membershipApi.post('/removeAvatar', params);

export const getClubs = async (params) => membershipApi.get('/GetClubs', { params });

export const createOrUpdateOrder = async (params) => membershipApi.post('/CreateOrUpdateOrder', params);

export const processPayment = async () => membershipApi.get('/ProcessPayment');

export const checkDiscountCode = async (params) => membershipApi.post('/CheckDiscountCode', params);

export const releaseAccount = async (params) => membershipApi.post('/ReleaseAccount', params);

export const getTransactions = async (params) => membershipApi.get('/GetTransactions', params);
